import { Component } from '@angular/core';
import {AppConfigService} from "../../shared/services/config/app-config.service";

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent {
  appConfig = AppConfigService.config;
  currentYear: number = new Date().getFullYear();

}
